const APP_MODE = {
  production: 1,
  development: 0

}

// let LOG_TYPE = {
//   default: 0,
//   varDump:1,
//   debug: 2,
//   trace:30,
//   status: 50,
// } // moved to theme file


// to implement
window.WebCurrentEnviroment = APP_MODE.production

window.environmentVariables = {
  mode: WebCurrentEnviroment,
  log:{
    enabled: true,
    logLevel: 
      (WebCurrentEnviroment == APP_MODE.production) 
      ? LOG_TYPE.status 
        : LOG_TYPE.varDump
  }
}